import React, { useEffect } from "react";
import { data } from "./data";
import Products from "./Products";
import { useState } from "react";

function CompareCard({
	productData,
	setProductData,
	labor,
	project,
	warrantyOption,
	setWarrantyOption,
}) {
	let MVIS;
	if ((project == 0) | (project == 2)) {
		MVIS = true;
	}

	const [warrantyTxt, setWarrantyTxt] = useState("");
	useEffect(() => {
		setProductData(data[project]);
	}, [project]);
	useEffect(() => {
		getWarrantyTxt();

		setWarrantyOption(1);
		setTotal();
	}, [productData.name]);

	useEffect(() => {
		setTotal();
	}, [productData.material]);

	useEffect(() => {
		setProductLabor();
		setTotal();
	}, [labor]);

	useEffect(() => {
		if (warrantyOption == 0) {
			removeWarranty();
		} else {
			addWarranty();
		}
		setTotal();
	}, [warrantyOption]);

	useEffect(() => {
		setWarrantyOption(1);
	}, []);

	const getWarrantyTxt = () => {
		for (let i = 0; i < data[project].products.length; i++) {
			if (data[project].products[i].warranty === 25) {
				setWarrantyTxt("25 Year Warranty");
			} else if (data[project].products[i].warranty === 15) {
				setWarrantyTxt("15 Year Warranty");
			}
		}
	};

	const addWarranty = () => {
		//makes sure warranty is only added for MVIS products
		if (MVIS) {
			let currentProductList = productData.products;
			let fullProductList = data[project].products;
			for (let i = 0; i < fullProductList.length; i++) {
				if (currentProductList.indexOf(fullProductList[i]) === -1) {
					currentProductList.push(fullProductList[i]);
				}
			}
			const productFullNew = {
				...productData,
				products: currentProductList,
			};
			setProductData(productFullNew);
		}
	};

	const removeWarranty = () => {
		const newProducts = productData.products.filter(
			(product) => (product.warranty == 1) | (product.warranty == 0)
		);

		const productFullNew = {
			...productData,
			products: newProducts,
		};

		setProductData(productFullNew);
	};

	const WarrantySelector = () => {
		const newProducts = productData.products.filter(
			(product) => product.warranty !== 0
		);
		if (newProducts.length > 0) {
			function handleSelectChange(event) {
				setWarrantyOption(event.target.value);

				if (event.target.value == 1) {
					addWarranty();
				} else {
					removeWarranty();
				}
			}

			return (
				<div className="col-xs-2 input-group  warranty-selector w-50">
					<label className="label-top" htmlFor="warranty-select">
						{" "}
						System Warranty:{" "}
					</label>
					<div className="col-xs-2">
						<select
							id="warranty-select"
							value={warrantyOption}
							onChange={handleSelectChange}
							className="form-select bg-gray selectboxit-optout"
						>
							<option value="0">1 year warranty </option>
							<option value="1">{warrantyTxt}</option>
						</select>
					</div>
				</div>
			);
		}

		return (
			<div className="col-xs-2 input-group  warranty-selector w-50 form-select selectboxit-optout">
				<label className="label-top" htmlFor="warranty-select">
					System Warranty:{" "}
				</label>
				<p className="no-warranty-text">No Warranty Available</p>
			</div>
		);
	};

	const setTotal = (id, total) => {
		const productPrevious = productData.products.find(function (rec) {
			return rec.id === id;
		});

		const productUpdated = {
			...productPrevious,
			total: total,
		};

		const productNew = productData.products.map(function (rec) {
			return rec.id === id ? productUpdated : rec;
		});

		const productFullNew = {
			...productData,
			products: productNew,
		};

		//calculate new final totals
		let newFinalTotal = 0;
		let newFinalMaterial = 0;
		let newFinalTime = 0;
		let newFinalLabor = 0;
		productFullNew.products.map((product) => {
			newFinalMaterial += product.material;
			newFinalTime += product.time;
			newFinalLabor += product.labor;
		});

		newFinalTotal = newFinalMaterial + newFinalLabor;

		productFullNew.finalTotal.total = newFinalTotal;
		productFullNew.finalTotal.material = newFinalMaterial;
		productFullNew.finalTotal.time = newFinalTime;
		productFullNew.finalTotal.labor = newFinalLabor;
		setProductData(productFullNew);
	};

	const setMaterial = (id, materialCost) => {
		const productPrevious = productData.products.find(function (rec) {
			return rec.id === id;
		});

		const productUpdated = {
			...productPrevious,
			material: materialCost,
		};

		const productNew = productData.products.map(function (rec) {
			return rec.id === id ? productUpdated : rec;
		});

		const productFullNew = {
			...productData,
			products: productNew,
		};

		setProductData(productFullNew);
	};

	const setProductLabor = () => {
		let laborSec = labor / 3600;

		productData.products.map((product) => {
			product.labor = product.time * laborSec;
		});
	};

	return (
		<div className="Card">
			<h3> {productData.name} </h3>
			<p>{productData.description}</p>
			<WarrantySelector />
			<div className="product-table">
				<div className="row product-data product-data-header">
					<div className="col-3 col-sm-5">
						<p>
							<b> Assembly Item </b>
						</p>
					</div>
					<div className="col-3 col-sm-2">
						<p>
							<b> Material </b>
						</p>
					</div>
					<div className="col">
						<p>
							<b>Time </b>
						</p>
					</div>
					<div className="col">
						<p>
							<b> Labor </b>
						</p>
					</div>
					<div className="col">
						<p>
							<b> Total</b>
						</p>
					</div>
				</div>

				<div id={`${productData.name}`}>
					{productData.products.map((product) => {
						return (
							<Products
								key={product.id}
								product={product}
								setMaterial={setMaterial}
								setTotal={setTotal}
								setProductLabor={setProductLabor}
								warranty={warrantyOption}
							/>
						);
					})}
				</div>

				<div className="final-total row">
					<div className="col-5-lg col-4 ">Total Cost/ft&sup2;</div>

					<div className="col-2">
						<b>${productData.finalTotal.material.toFixed(2)}</b>
					</div>

					<div className="col">
						<b>{productData.finalTotal.time.toFixed(0)} s</b>
					</div>
					<div className="col">
						<b>${productData.finalTotal.labor.toFixed(2)}</b>
					</div>
					<div className="col final-total-total">
						<b>${productData.finalTotal.total.toFixed(2)}</b>
					</div>
				</div>
			</div>
			<div className="pros-cons-holder">
				<div className="pros-cons">
					<p>
						{" "}
						<i className="fa check">&#10003;</i>
						<i className="x">&#10060;</i>
						{productData.proCon[0]}
					</p>

					<p>
						<i className="fa check">&#10003;</i>
						<i className="x">&#10060;</i>
						{productData.proCon[1]}
					</p>

					<p>
						<i className="fa check">&#10003;</i> <i className="x">&#10060;</i>
						{productData.proCon[2]}
					</p>
				</div>
			</div>
		</div>
	);
}

export default CompareCard;
